import React from "react";
import { useSelector } from "react-redux";
import { Route, Switch } from "react-router-dom";

import { selector as authStoreSelector } from "../../store/AuthStore";

import BreadcrumbList from "./BreadcrumbList";
import { drawerItems } from "./DrawerItems";
import useStyles from "./useStyles";

/**
 * ページコンポーネント.
 *
 * @return {object} コンポーネント
 */
function Page() {
  const {
    // リモート保守可能フラグ（true: 可能、false: 不可能）
    isRemoteMaintenance,
    // ファイル一覧メニュー表示フラグ（true: 表示、false: 非表示）
    isDisplayFilesMenu,
    // 工番管理メニュー表示フラグ（true: 表示、false: 非表示）
    isDisplayPressManagementMenu,
  } = useSelector(authStoreSelector);

  // スタイル
  const styles = useStyles();

  return (
    <div className={styles.page}>
      <div className={styles.toolbar} />
      <BreadcrumbList />
      <Switch>
        {isDisplayFilesMenu && (
          <Route key={drawerItems.files.id} exact path={drawerItems.files.path}>
            {drawerItems.files.component}
          </Route>
        )}
        <Route
          key={drawerItems.register.id}
          exact
          path={drawerItems.register.path}
        >
          {drawerItems.register.component}
        </Route>
        <Route
          key={drawerItems.dataGraph.id}
          exact
          path={drawerItems.dataGraph.path}
        >
          {drawerItems.dataGraph.component}
        </Route>
        <Route key={drawerItems.report.id} exact path={drawerItems.report.path}>
          {drawerItems.report.component}
        </Route>
        {isRemoteMaintenance && (
          <Route
            key={drawerItems.remoteMaintenance.id}
            exact
            path={drawerItems.remoteMaintenance.path}
          >
            {drawerItems.remoteMaintenance.component}
          </Route>
        )}
        {isDisplayPressManagementMenu && (
          <Route
            key={drawerItems.pressManagement.id}
            exact
            path={drawerItems.pressManagement.path}
          >
            {drawerItems.pressManagement.component}
          </Route>
        )}
      </Switch>
    </div>
  );
}

export default Page;
